import { put, takeLatest } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';
import PlanActionTypes from './types';
import {
  fetchConsignerPlanDetailsSuccess,
  fetchConsignerPlanDetailsFailure,
  initiateConsignerPlanPaymentSuccess,
  initiateConsignerPlanPaymentFailure,
  initiateConsignerPlanPaymentStatusSuccess,
  initiateConsignerPlanPaymentStatusFailure,
} from './actions';
import UrlConfig from './urls';

function* getConsignerPlanDetailsSaga(action: any) {
  const requestURL: any = UrlConfig.getPlanDetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchConsignerPlanDetailsSuccess(response));
  } catch (e) {
    yield put(fetchConsignerPlanDetailsFailure(e));
    console.log({ e });
  }
}

function* postInitiatePlanPaymentSaga(action: any) {
  const requestURL = UrlConfig.initiatePlanPayment();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(initiateConsignerPlanPaymentFailure(response?.data?.message || 'Something went wrong'));
    } else {
      yield put(initiateConsignerPlanPaymentSuccess(response));
    }
  } catch (e) {
    yield put(initiateConsignerPlanPaymentFailure(e));
    console.log({ e });
  }
}

function* postInitiateConsignerPlanPaymentStatusSaga(action: any) {
  const requestURL = UrlConfig.initiatePlanPaymentStatus();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(initiateConsignerPlanPaymentStatusFailure(response?.data?.message || 'Something went wrong'));
    } else {
      yield put(initiateConsignerPlanPaymentStatusSuccess(response));
    }
  } catch (e) {
    yield put(initiateConsignerPlanPaymentStatusFailure(e));
    console.log({ e });
  }
}

function* consignerPlanSaga() {
  yield takeLatest(PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_START, getConsignerPlanDetailsSaga);
  yield takeLatest(PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_START, postInitiatePlanPaymentSaga);
  yield takeLatest(
    PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_START,
    postInitiateConsignerPlanPaymentStatusSaga,
  );
}

export default consignerPlanSaga;
